<template>
  <div id="gallery-container">
    <div id="header" class="header">

      <div class="title">Strava Gallery<br><span class="muted">Paul's runs with photos</span></div>

      <div class="units">
        <toggle-button
                  id="switch"
                  label-enable-text="mi"
                  label-disable-text="km"
                  :default-state="true"
                  label-title-text="units"
                  v-on:change="toggleUnits"></toggle-button>

        <toggle-button
            id="switch-info"
            label-enable-text="on"
            label-disable-text="off"
            :default-state="true"
            label-title-text="info"
            v-on:change="toggleInfo"></toggle-button>
      </div>
      <div class="runs">{{stats.runs}} runs</div>
      <div class="filter years">
        <span v-for="year in timeFilters.years"
          :key="year.id"
          class="time year"
          :class="{'selected' : year.selected === true}"><a href="javascript:void(0);" @click="toggleFilter('years', year.id)">{{year.name}}</a></span>
      </div>
      <div class="filter months">
        <span v-for="month in timeFilters.months"
          :key="month.id"
          class="time month"
          :class="{'selected' : month.selected === true}"><a href="javascript:void(0);" @click="toggleFilter('months', month.id)">{{month.name}}</a></span>
      </div>

    </div>

    <div id="gallery" style="margin-top: 50px;">
      <masonry
      :cols="{default: 5, 1600: 4, 1000: 3, 700: 2, 400: 1}"
      :gutter="{default: 0, 700: 0}">

        <div v-for="day in filteredDays" :key="day.date" class="day">

          <div v-for="run in day.runs" :key="run.id" class="run" :class="run.run_type">
            <div v-show="info" class="run-info">
              <div class="meta">
                <span class="metric date">{{moment(day.date + ' ' + run.start_time_local).format('ddd Do MMM YYYY  &middot; HH:mm')}} </span>
                <span class="metric">
                  <span class="time">{{run.duration[0]}} {{run.duration[1].toLowerCase()}}</span>
                   &nbsp;&middot;&nbsp;
                  <span class="pace">{{run[units].pace}} min/{{units}}</span>
                  &nbsp;&middot;&nbsp;
                  <span class="elevation">{{Number(run.total_elevation_gain[elevationUnits[units]]).toLocaleString()}} {{elevationUnits[units]}}</span>
                </span>
              </div>
              <a :href="'https://strava.com/activities/'+run.id" title="Stava" class="strava-link" target="_blank">
              <div class="map-tile">
                <poly-to-s-v-g :poly-line="run.map_polyline" :runid="run.id" @click="lightboxEffect(index)"></poly-to-s-v-g>
              </div>
              <div class="strava-link-cont">
                <img src="/images/strava-ico.svg" class="strava-ico" /></div>
                <div class="dist" :style="{ 'background-color': distColour(run.distance_meters) }">
                  <span class="datum">{{run[units].dist}}</span><span class="units">{{units}}</span>
                </div>
              </a>
            </div>
            <div v-if="run.thumbs">
              <LightBox
                :thumbnails="run.thumbs"
                :largeImages="run.photos"
                :thumbnailsPath="''"
                :largePath="''"
                :captions="[]"
                class="lightBox"
              />

            </div>
          </div>
        </div>
    </masonry>
  </div>
  </div>
</template>

<script>
import days from "@/assets/data/race-report_runs.json";
import ToggleButton from "@/components/ToggleButton.vue";
import LightBox from "@/components/LightBox";
import PolyToSVG from "@/components/PolyToSVG";
import * as d3 from "d3";

//const BUCKETS = [999, 60, 25, 14, 8, 6, 5, 4, 3, 2, 0];
const BUCKET_COLOURS = [
    "rgb(54, 142, 144)",
    "rgb(54, 142, 144)",
    "rgb(92, 181, 124)", //40, 155, 81
    "rgb(115, 195, 100)",
    "rgb(182, 224, 118)",
    "rgb(219, 239, 103)", //233, 245, 161
    "rgb(253, 224, 93)", // 254, 237, 161
    "rgb(253, 190, 112)",
    "rgb(244, 124, 74)",
    "rgb(216, 56, 45)",
    "rgb(165, 0, 38)"
];
const MONTHS = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'All'
];

export default {
  name: 'AnnualRuns',
  components: {
    LightBox: LightBox,
    "toggle-button": ToggleButton,
    PolyToSVG: PolyToSVG
  },
  props: {
    msg: String
  },
  data() {
    return {
      days: days,
      units: 'mi',
      info: true,
      elevationUnits: {
        mi: 'feet',
        km: 'meters'
      },
      index: null,
      stats: {
        distMax: 0,
        distMin: 0,
        runs: 0,
        distance: 0,
        months: [],
        years: []
      },
      showNoPhoto: false,
      timeFilters: {
        months: [],
        years: []
      }
    };
  },
  computed: {
    distMin(){
      let $vm = this;
      return d3.min(d3.map($vm.filteredDays, (d) => d.runs[0].distance_meters));
    },
    distMax(){
      let $vm = this;
      return d3.max(d3.map($vm.filteredDays, (d) => d.runs[0].distance_meters));
    },
    distColour() {
      let $vm = this;
      return d3.scaleQuantize()
      .domain([$vm.distMin, $vm.distMax])
      .range(BUCKET_COLOURS);
    },
    /*
    photoStream() {
      let $vm = this;
      $vm.stats.runs = 0;

      let pics =  this.days.filter(day => {
        let yIdx = $vm.timeFilters.years.map(y => y.name).indexOf(day.year.toString());
        if (
            ($vm.showNoPhoto || day.day_has_photos) &&
            (
                ($vm.timeFilters.months[day.moy-1].selected || $vm.timeFilters.months[$vm.timeFilters.months.length-1].selected) &&
                ($vm.timeFilters.years[yIdx].selected || $vm.timeFilters.years[$vm.timeFilters.years.length-1].selected)
            )
        ) {
          $vm.stats.runs++;
          return true;
        }
        return false;
      }).sort((a, b) => a.date < b.date ? 1 : -1 )
      .map(day => {
        return day.runs.map(run => {
          return run.photos.map(photo => photo.url)
        })
      });
      console.log(pics);
      return pics;

    },
     */
    filteredDays() {
      let $vm = this;
      $vm.stats.runs = 0;

      return this.days.filter(day => {
        let yIdx = $vm.timeFilters.years.map(y => y.name).indexOf(day.year.toString());
        if (
            ($vm.showNoPhoto || day.day_has_photos) &&
            (
              ($vm.timeFilters.months[day.moy-1].selected || $vm.timeFilters.months[$vm.timeFilters.months.length-1].selected) &&
              ($vm.timeFilters.years[yIdx].selected || $vm.timeFilters.years[$vm.timeFilters.years.length-1].selected)
            )
          ) {
          $vm.stats.runs++;
          return true;
        }
        return false;
      }).sort((a, b) => a.date < b.date ? 1 : -1 );
    }
  },
  created() {
    let lu = {
      years: {},
      months: {}
    }
    this.days.forEach(day => {
      lu.years[day.year] = true;
      lu.months[day.moy] = true;
    });

    let sortedYears = Object.keys(lu.years).sort((a, b) => +a - +b );
    let months = MONTHS.map((month, mid) => { return {id: mid, name: month, selected: false }; });

    let years = sortedYears.map((year, idx)  => { return {id: idx, name: year, selected: false }; });
    years[years.length-1].selected = true;
    years.push({ id: years.length, name: 'All', selected: false });
    months[12].selected = true;
    this.timeFilters.years = years
    this.timeFilters.months = months;

    window.addEventListener("resize", this.resizeHandler);
  },
  mounted() {
    this.resizeHandler();
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeHandler);
  },
  methods: {
    toggleFilter(type, value){
      this.timeFilters[type][value].selected = !this.timeFilters[type][value].selected;

      if (value === this.timeFilters[type].length-1 && this.timeFilters[type][value].selected){
        this.timeFilters[type].forEach((unit, id) => {
          if (id < this.timeFilters[type].length-1){
            unit.selected = false;
          }
        });
      }
      else {
        this.timeFilters[type][this.timeFilters[type].length-1].selected = false;
      }
    },
    nodefault(photos) {
      return photos.filter(p => !p.default_photo);
    },
    runMaptile(run){
      return `./images/map-tiles/${run.start_date}_runmap_${run.id}.png`;
    },
    toggleUnits: function(){
      this.units = this.units === 'mi' ? 'km' : 'mi';
    },
    toggleInfo: function(){
      this.info = !this.info;
    },
    resizeHandler() {
      let headerHeight = document.getElementById("header").offsetHeight;
      document.getElementById("gallery").style.marginTop = headerHeight + 'px';
    },
    lightboxEffect(curr) {
      this.currentImage = curr;
      this.bg = !this.bg;
      document.getElementById("page-body").className = 'modal-open';
    },
  }
}
</script>

<style lang="scss">
  .map-tile {
    height: 52px;
    width: 52px;
    .map_thumbnail {
      width: 100%;
      height: 100%;
    }
  }
</style>
